/****************ELEMENTS*****************/
//this obj define, the actions realeted to each
//th>table header and td
const timeDate = require("../../../../../js-handler/time-date");

function getTdDataDetail(dest, entity, dbid) {
  return `data-detail='{ 
      "click": [ 
        {"dest":"ripple"},
        {"dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "act":"selectOne", "entity":"${dest}", "dbid":"${dbid}"}
      ],
      "clickRight": [ 
        {"dest":"clientActivity", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"clientActivity", "dbid":"${dbid}"}
      ] 
  }'`;
}

export const tableDetail = {

  entity: "clientActivity", //name table on the db
  dest: "clientActivity", //name of the entity on the system

  //action for body
  //left click, directly to the fullcont
  tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"clientActivity", "elem":"page", "act":"removeFc"}  ],
                                
                                 "clickRight": [{"dest":"purchase", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"purchase", "dbid": "#dbid" } ]  }'`,

  // andry 28/12/2023
  filter: {
    mainFilterFields: [
      "name"
    ],
    mainFilterValues: ["", ""],
    andFilterFields: [""],
    andFilterValues: [""],
  },
};

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) {
  var newData = [];

  if (data.length === 0) {
    newData.push({
      id: "nothing",
      colum: [
        { label: "No Results", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
      ],
    });
    return newData;
  }

  data.forEach((elem) => {
    let text;
    // let subTextStatus;
    let textBill;
    let subTextBill;
    let color;
    let transactionType;
    let newEntity;

    let customAvatarLetter = 'NA'; // Valor por defecto
    if (elem.transactionType === 'purchase' || elem.transactionType === 'expense') {
      customAvatarLetter = './css/svg.svg#check-round';
      color = "tdWithIcon td-green-icon";
      transactionType = 'Purchase';
      newEntity = 'clientPurchase';
    } else if (elem.transactionType === 'sale') {
      customAvatarLetter = './css/svg.svg#check-round';
      color = "tdWithIcon td-red-icon";
      transactionType = 'Sale';
      newEntity = 'clientSale';
    }

    newData.push({
      id: elem.doc_id,
      tdDataDetail: getTdDataDetail(newEntity, elem.transactionType, elem.doc_id),
      colum: [
        {
          label: `${transactionType} - ${elem.category}`,
          span: elem.current,
          style: {
            tdClass: color,
            svg: customAvatarLetter,
          },
        },

        { label: elem.total_due_30_days },
        { label: elem.total_due_31_to_60_days },
        { label: elem.total_due_61_to_90_days },
        { label: elem.total_due_over_90_days },

        // { label: timeDate.friendlyDate(elem.dateDt),  span: ""},

      ],
    }); /*push*/
  }); /*forEach*/

  return newData;
}

export function organizeRowEntityChange(data) {
  let newData = "";
  let avatar = "";
  let changes_inputs;
  let changes_mt;

  data.forEach((elem) => {
    if (elem.avatar == "") {
      avatar = "css/img/pic/person.svg";
    } else {
      avatar = elem.avatar;
    }

    newData += `<cont> 
                        <user>
                            <photo class="photo" 
                            style="background-image: url('${avatar}')"></photo>
                            <title>${elem.user_name.trim()}</title>
                            <time>${timeDate.friendlyDate(elem.date_change) +
      " | " +
      timeDate.friendlyTime(
        elem.date_change.substring(10)
      )
      }</time>
                        </user>

                        <entry>
                            <div class="row">
                                <div class="c33">Data</div><!-- c16 -->
                                <div class="c33">From</div><!-- c16 -->
                                <div class="c33">To</div><!-- c16 -->
                            </div><!-- row --> 
        
                    `;

    changes_inputs = JSON.parse(elem.changes).input;

    changes_inputs.forEach((input) => {
      newData += `
                            <div class="row">
                                <div class="c33">${input.elemId}</div><!-- c16 -->
                                <div class="c33">${input.from}</div><!-- c16 -->
                                <div class="c33">${input.to}</div><!-- c16 -->
                            </div><!-- row --> 
            `;
    });

    changes_mt = JSON.parse(elem.changes).mt;
    if (changes_mt.length > 0) {
      newData += `     </entry>
                        <entry>
                            <div class="row mt-8">
                                <div class="c16">Status</div><!-- c16 -->
                                <div class="c16">Items</div><!-- c16 -->
                                <div class="c16">Units</div><!-- c16 -->
                                <div class="c16">Qty</div><!-- c16 -->
                                <div class="c16">Unit Price</div><!-- c16 -->
                                <div class="c16">Total</div><!-- c16 -->
                            </div><!-- row --> `;
    }

    changes_mt.forEach((mt) => {
      mt.from.forEach(function (mt_from, index) {
        newData += `
                    <div class="row">
                        <div class="c16">From</div><!-- c16 -->
                        <div class="c16">${mt_from.id}</div><!-- c16 -->
                        <div class="c16">${mt_from.selling_type
          }</div><!-- c16 -->
                        <div class="c16">${mt_from.qty}</div><!-- c16 -->
                        <div class="c16">${"$" + mt_from.price
          }</div><!-- c16 -->
                        <div class="c16">${"$" + mt_from.total
          }</div><!-- c16 -->
                    </div><!-- row -->`;

        // Verificar si hay datos en mt.to
        if (mt.to && mt.to[index]) {
          newData += `
                    <div class="row">
                        <div class="c16">To</div><!-- c16 -->
                        <div class="c16">${mt.to[index].id}</div><!-- c16 -->
                        <div class="c16">${mt.to[index].selling_type
            }</div><!-- c16 -->
                        <div class="c16">${mt.to[index].qty}</div><!-- c16 -->
                        <div class="c16">${"$" + mt.to[index].price
            }</div><!-- c16 -->
                        <div class="c16">${"$" + mt.to[index].total
            }</div><!-- c16 -->
                    </div><!-- row -->`;
        }
      });
    });

    newData += `     </entry>
                   <cont>`;
  }); /*forEach*/

  return newData;
} /*organizeRow*/